<template>
  <el-dialog title="Register" :visible.sync="isShowRegisterForm"
    :closeOnClickModal="false"
    class="medium register-dialog"
    @open="onOpen"
    :custom-class="loading ? 'loading' : ''"
    >
    <el-form>
      <el-form-item :label="$t('TEXT_USERNAME')" :label-width="formLabelWidth">
        <el-input v-model="form.username" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TEXT_EMAIL')" :label-width="formLabelWidth">
        <el-input v-model="form.email" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TEXT_PASSWORD')" :label-width="formLabelWidth">
        <el-input v-model="form.password" autocomplete="off" type="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('TEXT_REF_CODE')" :label-width="formLabelWidth">
        <el-input v-model="form.ref_code" autocomplete="off" ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="register" :disabled="!isValidated" class="btn btn-primary"
       >{{ $t('BTN_REGISTER') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      form: {
        email: '',
        ref_code: '',
        password: '',
        username: ''
      },
      formLabelWidth: '120px'
    }
  },
  computed: {
    isShowRegisterForm: {
      get () {
        return this.$store.getters.isShowRegisterForm
      },
      set (val) {
        this.$store.dispatch('toggleRegisterFormModal')
        this.$store.dispatch('closeAllModal')
      }
    },
    configs () {
      return this.$store.getters.configs
    },
    isValidated () {
      return this.form.email && this.form.ref_code && this.form.password && this.form.username
    },
    account () {
      return this.$store.getters.account
    }
  },
  methods: {
    toggleModal () {
      this.$store.dispatch('toggleRegisterFormModal')
      this.$store.dispatch('closeAllModal')
    },
    onOpen () {
      const ref = this.$route.query.ref
      console.log(ref)
      ref && (this.form.ref_code = ref)
    },
    register () {
      if (!this.isValidated) return
      this.loading = true
      this.$store.dispatch('register', this.form).then(status => {
        if (status) {
          this.$store.dispatch('toggleRegisterFormModal')
          this.$store.dispatch('closeAllModal')
          this.$store.dispatch('logout')
        }
      }).catch(e => {
        this.$store.dispatch('showErrorMsg', 'System error')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
